import { useEffect, useState, memo } from "react";

import { processValue } from "#/utils/katex";

import type { Props } from "./types";

const Content = (props: Props) => {
  const { value = "" } = props;
  const [html, setHtml] = useState("");

  useEffect(() => {
    processValue(value).then(setHtml);
  }, [value]);

  return <div dangerouslySetInnerHTML={{ __html: html }} />;
};

export default memo(Content);
